const TRACT_PANEL_TYPES = {
  VISUALIZATION: 'visualization',
  SIMILAR_TRACTS: 'similar-tracts',
  COMPARE_SIMILAR_TRACTS: 'compare-similar-tracts',
  COMPARE_TRACTS: 'compare-tracts',
};

const COUNTY_PANEL_TYPES = {
  VISUALIZATION: 'visualization',
  COMPARE_COUNTIES: 'compare-counties',
};

const STATE_PANEL_TYPES = {
  VISUALIZATION: 'visualization',
  COMPARE_STATES: 'compare-states',
};

export { TRACT_PANEL_TYPES, STATE_PANEL_TYPES, COUNTY_PANEL_TYPES };
